/* eslint-disable react/destructuring-assignment */
import React, { Component } from '@ali/odin/react';
import styles from './index.less';
import Home from './Block/home';
import Make from './Block/make';
import Dev from './Block/dev';
import getUrlParam from '@/util/getUrlParam';

class Index extends Component<{}, {
  index: number;
  isLight: boolean;
  open: boolean;
  h5Menu: (onClick?: (e?: React.MouseEvent<HTMLLIElement, MouseEvent>, index?: number) => void) => JSX.Element | null;
}> {
  constructor(props) {
    super(props);
    this.state = {
      index: parseInt(getUrlParam('index') || '1'),
      isLight: false,
      open: false,
      h5Menu: () => null
    }
  }

  componentDidMount(){
    this.onScorll();
    document.body.onscroll = this.onScorll;
  }
  componentWillUnmount(){
    document.body.onscroll = null;
  }

  onScorll = () => {
    const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
    if (scrollTop > 100) {
      this.setState({isLight: true})
    }else{
      this.setState({isLight: false})
    }
  }

  go = (index: 1 | 2 | 3) => {
    // window.location.hash = '';
    // window.location.search = '?index=' + index; 
    this.setState({index, open: false});
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  } 

  render(){
    const { index, isLight, open } = this.state;
    return [
      <header key={1} className={`${styles.header} ${(index !== 1) || isLight ? styles.light : ''}`}>
        <div className={`${styles.container} ${styles.full}`}>
          <div className={styles.h5MenuIcon} onClick={() => {
            this.setState({open: true})
          }}></div>
          <div className={styles.logo} onClick={() => this.go(1)}></div>
          <nav>
            <ul className={styles.menu}>
              <li className={index === 1 ? styles.cur : ''} onClick={() => this.go(1)}>首页</li>
              <li className={index === 2 ? styles.cur : ''} onClick={() => this.go(2)}>创作标准</li>
              <li className={index === 3 ? styles.cur : ''} onClick={() => this.go(3)}>技术标准</li>
            </ul>
          </nav>
          <div className={styles.tip}></div>
        </div>
      </header>,
      <div key={2} style={open ? {width: '100%', height: '100%', position: 'fixed', zIndex: 997, overflow: 'hidden'} : {}}>{this.getBlock()}</div>,
      this.getH5Menu()
    ]
  }

  getBlock(){ 
    const { index } = this.state;
    switch (index) {
      case 1:
        return <Home go={this.go}/>
      case 2:
        return <Make onChange={this.setH5ChildMenu}/>
      case 3:
        return <Dev onChange={this.setH5ChildMenu}/>
      default:
        return <Home go={this.go}/>
    }
  }

  getH5Menu(){
    const { index, open, h5Menu } = this.state;
    return <nav className={styles.h5Menu} key={3} style={{display: open ? 'block' : 'none'}}>
      <div className={styles.h5MenuContent}>
        <div className={styles.close} onClick={() => {
            this.setState({open: false})
          }}></div>
        <ul>
          <li className={index === 1 ? styles.cur : ''}>
            <p onClick={() => this.go(1)}>首页</p>
          </li>
          <li className={index === 2 ? styles.cur : ''}>
            <p onClick={() => this.go(2)}>创作标准</p>
          </li>
          <li className={index === 3 ? styles.cur : ''}>
            <p onClick={() => this.go(3)}>技术标准</p>
          </li>
          <li>
            {
              (index === 2 || index === 3) && h5Menu ? <div className={styles.markdownMenu}>{h5Menu(() => {
                this.setState({open: false})
              })}</div> : null
            }
          </li>
        </ul>
      </div> 
    </nav>
  }

  setH5ChildMenu = ({ menu }) => {
    this.setState({
      h5Menu: menu
    })
  }
}

export default Index;
